import { IconLookup, IconName } from '@fortawesome/free-solid-svg-icons';

import { Icon } from 'apps/shared/scripts/components';

import {
  iconClassName,
  itemClassName,
  mediaClassName,
  subtitleClassName,
  textClassName,
  titleClassName,
} from './styles';

interface Props {
  icon: IconLookup | IconName;
  title: string;
  subtitle: string;
}

const ListItem = ({ icon, title, subtitle }: Props) => {
  return (
    <div className={itemClassName}>
      <div className={mediaClassName}>
        <Icon className={iconClassName} fa={icon} />
      </div>
      <div className={textClassName}>
        <h2 className={titleClassName}>{title}</h2>
        <h4 className={subtitleClassName}>{subtitle}</h4>
      </div>
    </div>
  );
};

ListItem.displayName = 'ListItem';

export default ListItem;
